import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
interface TimeParts {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
// Target: Día del Padre, 19 de junio del año en curso (fin del día).
function getTarget(): Date {
  const now = new Date();
  let year = now.getFullYear();
  let target = new Date(year, 5, 19, 23, 59, 59); // mes 5 = junio
  // Si ya pasó este año, apunta al próximo año.
  if (target.getTime() < now.getTime()) {
    target = new Date(year + 1, 5, 19, 23, 59, 59);
  }
  return target;
}
function getRemaining(target: Date): TimeParts {
  const diff = Math.max(0, target.getTime() - Date.now());
  const totalSeconds = Math.floor(diff / 1000);
  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor(totalSeconds % 86400 / 3600),
    minutes: Math.floor(totalSeconds % 3600 / 60),
    seconds: totalSeconds % 60
  };
}
export function UrgencyBar() {
  const [target] = useState(getTarget);
  const [time, setTime] = useState<TimeParts>(() => getRemaining(target));
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(getRemaining(target));
    }, 1000);
    return () => clearInterval(timer);
  }, [target]);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="bg-bbq-urgency text-white py-3 px-4 sticky top-0 z-50 shadow-lg border-b border-red-900/50" data-id="element-174">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center sm:text-left text-sm sm:text-base font-medium" data-id="element-175">
        <div className="flex items-center gap-2 uppercase tracking-wider font-display text-red-100" data-id="element-176">
          <span className="w-2 h-2 rounded-full bg-red-400 animate-pulse" data-id="element-177"></span>
          ¡Oferta de última hora!
        </div>
        <div className="hidden sm:block text-red-300" data-id="element-178">|</div>
        <p className="text-gray-100" data-id="element-179">
          El Día del Padre se acerca. Consigue el regalo y recíbelo al instante.
        </p>
        <div className="flex items-center gap-2 bg-black/30 px-3 py-1.5 rounded-md font-display tracking-wider text-bbq-gold" data-id="element-180">
          <Clock size={16} className="text-bbq-gold shrink-0" data-id="element-181" />
          <div className="flex items-center gap-2" data-id="element-182">
            <TimeUnit value={time.days} label="días" data-id="element-183" />
            <span className="text-red-300/70" data-id="element-184">:</span>
            <TimeUnit value={pad(time.hours)} label="hrs" data-id="element-185" />
            <span className="text-red-300/70" data-id="element-186">:</span>
            <TimeUnit value={pad(time.minutes)} label="min" data-id="element-187" />
            <span className="text-red-300/70" data-id="element-188">:</span>
            <TimeUnit value={pad(time.seconds)} label="seg" data-id="element-189" />
          </div>
        </div>
      </div>
    </div>;
}
function TimeUnit({
  value,
  label
}: {
  value: number | string;
  label: string;
}) {
  return <span className="flex flex-col items-center leading-none" data-id="element-190">
      <span className="text-base sm:text-lg font-bold tabular-nums" data-id="element-191">
        {value}
      </span>
      <span className="text-[9px] text-red-200/80 uppercase tracking-wide mt-0.5" data-id="element-192">
        {label}
      </span>
    </span>;
}